module.exports = "<button *ngFor=\"let r of runes\" (click)=\"writeRune(r)\">{{r}}</button>"